import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '../store/store'
import _ from 'lodash'
Vue.use(Router)

let _router = new Router({
    routes: routes
})

_router.beforeEach((to, from, next) => {
    var userAllowedToRoute = true
    var authActions = []

    if (to.matched.length === 0) {
        next('/404')
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.state.auth.loggedIn === false) {
            authActions.push(store.dispatch('auth/checkUserAuthenticated'))
        }
        if (store.state.auth.flatCurrentUserPermissions.length === 0) {
            authActions.push(store.dispatch('auth/fetchCurrentPermissions'))
        }
        Promise.all(authActions).catch(() => {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            })
        }).then(() => {
            if (to.meta.featureFlag) {
                if (!store.getters['getFeatureActiveByName'](to.meta.featureFlag)) userAllowedToRoute = false
            }

            if (to.meta.permissionsRequired) {
                const userPermissions = store.getters['auth/getCurrentUserFlatPermissions']

                const routeSatisfiesAllPermissions = to.meta.permissionsRequired
                    .every((requiredPermission) => userPermissions.find(permission => permission.name === requiredPermission))

                userAllowedToRoute = to.meta.permissionsRequired.length === 0 || routeSatisfiesAllPermissions
            }
            if (userAllowedToRoute) {
                next()
            } else {
                next('/invalid-permissions')
            }
        })
    } else {
        next()
    }
})
export default _router
